// extracted by mini-css-extract-plugin
export default {"CollapsibleTextGroup":"jnbU2thGNFOFlv8DYPjq","CollapsibleTextGroup__content":"oHdEsIk3PqFhBSWVq9Yp"};